import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { hasAtLeast } from "../auth/session";
import type { AppRole } from "../auth/session";

/**
 * Hides UI the current role may not use.
 *
 * This is presentation only. §3.4 is explicit that hiding without the backend
 * check is decoration — every route this guards must ALSO be refused server
 * side by requireAdmin(). Do both; neither alone is enough.
 */
export function RoleGate({
  atLeast = "admin",
  children,
  fallback = null,
}: {
  atLeast?: AppRole;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { appRole } = useAuth();
  return hasAtLeast(appRole, atLeast) ? <>{children}</> : <>{fallback}</>;
}

/** Shorthand for the common case. */
export function AdminOnly({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  return (
    <RoleGate atLeast="admin" fallback={fallback}>
      {children}
    </RoleGate>
  );
}
